// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header-container{
  margin-bottom: 0.25em;
}

.dashboard-studio-text {
    font-size: 1.5em; /* Increase font size */
    font-weight: bold;
    padding: 0.25em;
    font-family: Roboto,sans-serif;
  }

  .toolbar-with-shadow {
    box-shadow: 0px 2px 4px darkgray; /* Add shadow */
    padding: 0.2em;
  }
  
  .header-background-color{
    background-color: #FEFDED !important;
  }

  .brand-logo-image{
    padding: 0.25em;
    height: 2em;
    width: 2em;
    border-radius: 12px;
  }`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;AACvB;;AAEA;IACI,gBAAgB,EAAE,uBAAuB;IACzC,iBAAiB;IACjB,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,gCAAgC,EAAE,eAAe;IACjD,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;IACV,mBAAmB;EACrB","sourcesContent":["\n.header-container{\n  margin-bottom: 0.25em;\n}\n\n.dashboard-studio-text {\n    font-size: 1.5em; /* Increase font size */\n    font-weight: bold;\n    padding: 0.25em;\n    font-family: Roboto,sans-serif;\n  }\n\n  .toolbar-with-shadow {\n    box-shadow: 0px 2px 4px darkgray; /* Add shadow */\n    padding: 0.2em;\n  }\n  \n  .header-background-color{\n    background-color: #FEFDED !important;\n  }\n\n  .brand-logo-image{\n    padding: 0.25em;\n    height: 2em;\n    width: 2em;\n    border-radius: 12px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
